module.exports = __webpack_public_path__ + "img/hr-sand-transition.39e85d7c.png";